const getShortMonthNames = () => ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const getMonthNames = () => ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export { getMonthNames, getShortMonthNames };
